import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogTitle } from '@material-ui/core/';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IpaasService from '../../../services/IpaasService/IpaasService';
import BotService from '../../../services/BotService/BotService';
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../recoil-store/recoil-state';

/**
 * @Description This function lets you return component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function ResponseDialog({ open, setOpen, fetchData, type }) {
    const { t } = useTranslation();
    const [disable, setDisable] = useState(false);
    const label = 'CONTENT.PUBLISH-APPROVE.';
    const setAlert = useSetRecoilState(alertState);

    const handleClose = () => {
        setOpen({ ...open, open: false });
    };

    const handleAccept = () => {
        handleStatusService('APPROVED');
    };

    const handleReject = () => {
        handleStatusService('REJECTED');
    };

    const handleCancel = () => {
        handleStatusService('CANCELED');
    };

    const handleReactive = () => {
        handleStatusService('PENDING');
    }

    const handleStatusService = async (status) => {
        setDisable(true);
        const description = document.getElementById('filled-multiline-static').value;
        let response;
        if (type === 'bot') {
            response = await BotService.putApprovement(open.bot.approvement_id, {
                approve_status: status,
                description,
                bot_type: open.bot.bot_type
            });
        } else {
            response = await IpaasService.putApprovement(open.bot.integration_approvements_id, {
                approve_status: status,
                description
            });
        }
        if (response) {
            setAlert(alert => ({ ...alert, show: true, message: t(label + 'AUTOMATION-APPROVEMENT-' + response.message), severity: response.status ? 'success' : 'error' }));
        }
        else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }));
        }
        setDisable(false);
        fetchData(open.type === 'approve' ? 1 : 0);
        setOpen({ ...open, open: false });
    }

    return (
        <Dialog id="credential-response-modal" open={true} onClose={handleClose}>
            <DialogTitle id="alert-dialog-title" >
                <div id="about-title">
                    <span style={{ marginTop: 7 }}>
                        {t(label + 'REQUEST')}
                    </span>
                    <Button data-test="canceldialog-button" onClick={handleClose}>
                        {t('CONTENT.ABOUT.CLOSE')}
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div style={{ marginTop: 10 }}>
                    <span style={{ marginRight: 20 }}>
                        <b>{t('CONTENT.REQUEST-TAB.REQUESTING-USER')} : </b>&nbsp; {open.bot.published_by_fullname}
                    </span>
                    <span style={{ marginLeft: 20 }}>
                        <b>{t(label + 'BOT-NAME')} : </b>&nbsp; {open.bot.name}
                    </span>
                </div>
                <div style={{ marginTop: 16, marginBottom: 10 }}>
                    <b>{open.type === 'reactive' ? t(label + 'REQUEST-REACTIVE-STATEMENT') : t('CONTENT.REQUEST-TAB.REQUEST-CLOSURE-STATEMENT')} : </b>
                </div>
                <TextField id="filled-multiline-static" autoFocus multiline rows={5} variant="filled" fullWidth />
            </DialogContent>
            <DialogActions style={{ justifyContent: 'space-between', padding: '8px 24px 16px 24px' }}>
                {open.type === 'approve' ? <><Button onClick={handleReject} disabled={disable} color="secondary" style={{ textTransform: 'none' }} variant="outlined">
                    {t('CONTENT.REQUEST-TAB.REJECT-REQUEST')}
                </Button>
                    <Button onClick={handleAccept} disabled={disable} color="primary" style={{ textTransform: 'none' }} variant="outlined">
                        {t('CONTENT.REQUEST-TAB.ACCEPT-REQUEST')}
                    </Button></> : open.type === 'cancel' ?
                    <Button onClick={handleCancel} color="secondary" variant="outlined">{t(label + 'CANCEL-REQUEST')}</Button> : <>
                        <div></div>
                        <Button onClick={handleReactive} color="primary" variant="outlined">{t(label + 'REACTIVE')}</Button></>
                }
            </DialogActions>
        </Dialog>
    );
}
export default ResponseDialog;